module.exports = __webpack_public_path__ + "img/2.3-711x800.0f53fbce.jpg";